import AttachmentsView from "./AttachmentsView";

export default AttachmentsView;
